import { failure, pending, success } from '../../core';

import { HealAPI } from '../../../healApi';
import { toast } from '../../message/actions';

export class CartActions {
  public static EDIT_ACCOUNT = `CART_EDIT_ACCOUNT`;
}

export function editUserAccount(userAccountId: string, data: any) {
  return (dispatch: any) => {
    dispatch({ type: pending(CartActions.EDIT_ACCOUNT) });

    HealAPI.editUserAccount(userAccountId, data).then(
      (response: any) => {
        if (response.ok && response.data) {
          dispatch(
            toast({
              type: 'success',
              title: 'Success',
              content: 'Account information has been updated',
            })
          );
          dispatch({
            type: success(CartActions.EDIT_ACCOUNT),
            data: response.data,
          });
        } else {
          dispatch(
            toast({
              type: 'error',
              title: 'Error',
              content: (response.data || ({} as any)).description || 'Account information could not be updated',
            })
          );
          dispatch({
            type: failure(CartActions.EDIT_ACCOUNT),
            data: response,
          });
        }
      },
      (response: any) => {
        dispatch(
          toast({
            type: 'error',
            title: 'Error',
            content: (response.data || ({} as any)).description || 'Account information could not be updated',
          })
        );
        dispatch({
          type: failure(CartActions.EDIT_ACCOUNT),
          data: response,
        });
      }
    );
  };
}
